import { Observable } from 'rxjs';

export type Unsubscribe = () => void;

/**
 * Adapts a callback-style realtime subscription to an Observable whose
 * lifetime is the subscription's: subscribing opens the channel, unsubscribing
 * closes it, and events delivered after that are dropped.
 */
export function realtimeEvents<E>(
  subscribe: (callback: (event: E) => void) => Unsubscribe
): Observable<E> {
  return new Observable<E>((subscriber) => subscribe((event) => subscriber.next(event)));
}
